var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('a',{attrs:{"href":_vm.covidURL,"target":"_blank"}},[_vm._v(" Change your bottom line. Click for Covid relief fees. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }